import React from "react";
import { validEmail } from "@/shared/helpers";
import { Form, Field } from "react-final-form";
import TemplateButton from "@/shared/components/TemplateButton";
import { ApiErrorMessage } from "@/shared/components/flash";
import { useTranslation } from "react-i18next";
import { Spinner } from "reactstrap";
import { useSearchParams } from "react-router-dom";

const ForgotForm = ({ onSubmit, loading, errors }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const prefillEmail = searchParams.get("email") || "";
  // useEffect(() => {
  // });

  const validate = (values) => {
    let errors = {};
    if (!values.email) {
      errors.email = t("email_is_required");
    } else if (!validEmail(values.email)) {
      errors.email = t("invalid_email_address");
    }
    return errors;
  };

  const getGlobalError = () => {
    if (!errors) return null;

    if (typeof errors === "string") return errors;
    if (errors.message) return errors.message;
    if (errors.errors?.domain) {
      // Map backend "Invalid domain or account" to friendly message
      if (errors.errors.domain[0] === "Invalid domain or account") {
        return "You are not assigned to this program. Please contact your Administrator!!";
      }
      return errors.errors.domain[0]; // fallback if different message
    }      // 500 domain error

    return null;
  };

  // const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  // const onSubmit = async values => {
  //   await sleep(400);
  //   window.location = '/forgot/checkemail'
  // }

  return (
    <Form onSubmit={onSubmit} validate={validate} initialValues={{ email: prefillEmail }}>
      {({ handleSubmit, form, submitting, pristine, values }) => (
        <form className="form" onSubmit={handleSubmit}>
          <div className="card-header">{t("forgot_password")}</div>

          <div className="card-body">
            <p className="py-2">{t("enter_email_use_sign_in")}</p>

            {getGlobalError() && (
              <div className="alert alert-danger">{getGlobalError()}</div>
            )}

            {errors && <ApiErrorMessage errors={errors} showLabel={false} />}

            <Field name="email">
              {({ input, meta }) => (
                <div className="mb-3">
                  <label htmlFor="loginInputEmail" className="form-label">
                    {t("email_address")}
                  </label>
                  <input
                    id="loginInputEmail"
                    type="text"
                    {...input}
                    placeholder="Email"
                    className="form-control"
                  />
                  {meta.touched && meta.error && (
                    <span className="form-error">{meta.error}</span>
                  )}
                </div>
              )}
            </Field>

            <div className="d-flex justify-content-between">
              <div>
                <TemplateButton
                  type="submit"
                  disabled={loading}
                  text={t("continue")}
                  className="mr-2"
                />
                {loading && (
                  <Spinner
                    animation="border"
                    size="sm"
                    className="text-center"
                    variant="warning"
                  />
                )}
              </div>
              <TemplateButton
                link="/login"
                text={t("back_to_sign_in")}
                color="outline-secondary"
                className="border-1"
              />
            </div>
          </div>
        </form>
      )}
    </Form>
  );
};

export default ForgotForm;
